import React from 'react';
import GuideSection from '../../shared/guideSection/GuideSection';

const SystemGuideOverview = ({ sections }) =>
  sections.map((section) => (
    <GuideSection key={section.id} section={section} />
  ));

export default SystemGuideOverview;
